import Axios from 'middleware/axiosInstance'
import React, { useEffect, useState } from 'react'
import { Button, Space, Table, Input } from "antd";
import { Link, useNavigate } from 'react-router-dom';
import Loading from 'layouts/Loading/Loading';

function Categories() {
  const navigate = useNavigate();

  const [allCategories, setAllCategories] = useState(null)
  const [filteredInfo, setFilteredInfo] = useState({});
  const [sortedInfo, setSortedInfo] = useState({});
  const [searchText, setSearchText] = useState('');

  const getAllCategories = () => {
    Axios.get("/content")
      .then((res) => {
        setAllCategories(res.data)
      })
      .catch(err => console.log(err))
  }

  useEffect(() => {
    getAllCategories()
  }, []);

  const clearFilters = () => {
    setFilteredInfo({});
  };

  const clearAll = () => {
    setFilteredInfo({});
    setSortedInfo({});
    setSearchText('');
  };
  const handleChange = (pagination, filters, sorter) => {
    setFilteredInfo(filters);
    setSortedInfo(sorter);
  };

  const deleteContent = (content) => {
    if (window.confirm(`آیا "${content.contents_fa}" حذف گردد؟`)) {
      deleteContentHandler(content);
    }
  };

  const deleteContentHandler = (content) => {
    Axios.delete(`content/${content.id}`)
      .then((res) => {
        if (res.status === 204) {
          console.log(res);
        }
        getAllCategories()
      })
      .catch((err) => {
        console.log(err);
      })
      .finally(() => {
      });
  };
  const goToAddPage = () => {
    navigate("/contents/add")
  }

  const columns = [
    {
      title: "نام",
      dataIndex: "contents_fa",
      key: "contents_fa",
      sorter: (a, b) =>
        a.contents_fa > b.contents_fa ? 1 : b.contents_fa > a.contents_fa ? -1 : 0,
      sortOrder: sortedInfo.columnKey === "contents_fa" ? sortedInfo.order : null,
      ellipsis: true,
    },
    {
      title: "عملیات",
      dataIndex: "action",
      key: "action",
      render: (a, content) => (
        <Space size="small">
          <Link
            to={`/contents/edit/${content.id}`}
            className="btn btn-primary btn-sm"
          >ویرایش</Link>
          {/* <Link
            to={`/contents/`}
            className="btn btn-success btn-sm"
          >جزییات</Link> */}
          <button
            onClick={() => deleteContent(content)}
            className="btn btn-danger btn-sm"
          >حذف</button>
        </Space>
      ),
    },
  ];

  // Filter contents based on search text
  const filteredContents = allCategories?.filter(content => 
    content.contents_fa?.toLowerCase().includes(searchText.toLowerCase())
  ) || [];

  return (
    <div className="customized-container">
      <div className="customized-wrapper">
        <div>
          <Space
            style={{
              marginBottom: 16,
            }}
          >
            <Button onClick={goToAddPage}>اضافه کردن</Button>
            <Button onClick={clearFilters}>حذف فیلترها</Button>
            <Button onClick={clearAll}>حذف فیلتر و مرتب ها</Button>
          </Space>
          
          {/* Search Input */}
          <div style={{ marginBottom: 16 }}>
            <Input.Search
              placeholder="جستجو بر اساس نام ..."
              value={searchText}
              onChange={(e) => setSearchText(e.target.value)}
              style={{ width: 300 }}
              allowClear
            />
          </div>

          {allCategories ?
            filteredContents.length > 0 ?
              <Table
                pagination={false}
                columns={columns}
                dataSource={filteredContents}
                rowKey={allCategories.id}
                onChange={handleChange}
              />
              : searchText ? (
                <div className='vh-center mt-5'>
                  <h2>نتیجه‌ای برای جستجوی "{searchText}" یافت نشد</h2>
                </div>
              ) : (
                <h2>محتوایی نیست</h2>
              ) : <Loading />}
        </div>
      </div>
    </div>
  );
}
export default Categories